@if (chartHistory$ | async; as chartHistory) {
  @if (chartHistory.length) {
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>{{ label }}</mat-label>
      <mat-select [formControl]="chartCtrl" [compareWith]="compareFn">
        @if (allowEmpty) {
          <mat-option [value]="undefined">None</mat-option>
        }
        <mat-option
          *ngFor="let item of chartHistory; trackBy: trackByItem"
          [value]="item.value"
        >
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  }
}
